import React, { PureComponent } from 'react';
import SearchWidget from '../../../shared/search/search-widget';
import { GetCities } from '../../../../actions/cities';
import { withApollo } from 'react-apollo'; 
import { AddSector } from '../../../../actions/booking';
import { connect } from 'react-redux';
import { getCyoaID } from '../../../../helpers/cyoaHelper';
const queryString = require('query-string');


class GapPanel extends PureComponent {

    constructor(props){
        super(props);
        
        this.state = {
            activeCity:"",
            activeDate:""
        }
        
        this.cityClicked = this.cityClicked.bind(this);
        this.startDateClicked = this.startDateClicked.bind(this);
        this.onContinue = this.onContinue.bind(this);
        this.closeClicked = this.closeClicked.bind(this);
    }

    componentDidMount(){

        const { client, cities } = this.props;
        const parsed = queryString.parse(window.location.search);

        //Fetch network cities
        if(cities === undefined) GetCities(client, getCyoaID(parsed));

        document.body.addEventListener('CITY_CLICK', this.cityClicked);
        document.body.addEventListener('CITY_START_DATE_CLICK', this.startDateClicked);
    }

    componentWillUnmount(){
        document.body.removeEventListener('CITY_CLICK', this.cityClicked);
        document.body.removeEventListener('CITY_START_DATE_CLICK', this.startDateClicked);
    }


    cityClicked(e){
        //save active city
        this.setState({activeCity: e.detail });
    }

    startDateClicked(e){
        //save active city
        this.setState({activeDate: e.detail });
    }

    onContinue(){
        const { client, currentBooking:{uuid}, isLoading } = this.props;
        const { activeCity, activeDate } = this.state;
        const parsed = queryString.parse(window.location.search);

         //Add sector and toggle to builder view
         if(!isLoading){
            AddSector(client, uuid, getCyoaID(parsed), "start", activeCity, 0, activeDate, activeCity).then(() => {
                this.closeClicked();
            });
        }    
    }

    closeClicked(){
       this.props.onCloseClicked();
    }

    render(){

        const { activeCity, activeDate } = this.state;

        return(
            <div className="gap-panel">

                <div className="panel small-panel no-border pl0 pr0">
                    <div className="clearfix">
                        <div className="col col-12">
                            <p className="bold f-size-16 pt1 orange-text">
                                Add new destination date and create new sector
                                <svg className="inline-block button close-svg right" xmlns="http://www.w3.org/2000/svg" height="22.627" width="22.627" onClick={this.closeClicked}>
                                    <path fill="#ff6700" transform="rotate(45 11.314 11.314)" fillRule="evenodd" d="M18.98 10.314h-6.666V3.647a.333.333 0 0 0-.334-.333h-1.333a.333.333 0 0 0-.333.333v6.667H3.647a.333.333 0 0 0-.333.333v1.333c0 .185.149.334.333.334h6.667v6.666c0 .185.149.334.333.334h1.333c.185 0 .334-.15.334-.334v-6.666h6.666c.185 0 .334-.15.334-.334v-1.333"/>
                                </svg>
                            </p>
                        </div>
    
                    </div>
                </div>


                <div className="clearfix">
                    <div className="col col-12">
                        <SearchWidget builderAddGap={true} />
                    </div>
                </div>

                <div className="clearfix">
                    <div className={`col-12 sm-col-6 md-col-4 px2 mx-auto margin-t-40 margin-b-40`}>
                        <button className="busabout--cta orange rounded-corner full-width" onClick={this.onContinue} disabled={activeCity && activeDate ? false : true}>Continue</button>
                    </div>
                </div>

            </div>
        )
        
    }
}


const mapStateToProps = state => {
    return{
        agent:state.agent,
        cities:state.cities.cities,
        currentBooking:state.currentBooking,
        isLoading:state.cart.update_sector_loading
    }
}

export default withApollo(connect(mapStateToProps, null)(GapPanel));